<template>
    <!--  -->
     <div class="modal fade" id="createasupplierModal" tabindex="-1" aria-labelledby="createasupplierModalLabel" aria-hidden="true">
         <div class="modal-dialog modal-lg">
           <div class="modal-content">
             <div class="modal-header">
               <h5 class="modal-title" id="createasupplierModalLabel">Add Supplier</h5>
               <button type="button"  data-bs-dismiss="modal" aria-label="Close">X</button>
             </div>
             <div class="modal-body">
                 <!-- <form>
                     <div class="form-group">
                         <label for="exampleInputEmail1">Store Name</label>
                         <input name="store_name" v-on:keyup="handleKeyUp" type="text" class="form-control" placeholder="Enter store name">
                         <small id="emailHelp" class="form-text text-muted">This is creates a new item location</small>
                     </div>
                    
                   
                    
                 </form> -->

                

                 <form>

                    <div class="form-group">
                        <label for="inputAddress2">Supplier Name</label>
                        <input  v-on:keyup="handleKeyUp" name="supplier_name" type="text" class="form-control" id="inputAddress2" placeholder="enter name">
                    </div>  
                    <div class="form-group">
                        <label for="inputAddress">Supplier Email</label>
                        <input  v-on:keyup="handleKeyUp" type="email" name="contact_email" class="form-control" id="inputAddress" placeholder="enter email">
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6">
                        <label for="inputEmail4">Contact Person Name</label>
                        <input  v-on:keyup="handleKeyUp" type="text" name="contact_person" class="form-control" id="inputEmail4" placeholder="contact person">
                        </div>
                        <div class="form-group col-md-6">
                        <label for="inputPassword5">Contact Phone</label>
                        <input  v-on:keyup="handleKeyUp" name="contact_phone" type="number" class="form-control" id="inputPassword5" placeholder="Phone">
                        </div>
                    </div>
                  
                   
                    <div class="row">
                        <div class="form-group col-md-12">
                        <label for="inputCity">Supplier Address</label>
                        <input  v-on:keyup="handleKeyUp" name="address" type="text" class="form-control" id="inputCity"  placeholder="Supplier Address" >
                        </div>
                        
                    </div>
                    
                    <button @click="submitHandler" class="btn btn-primary righter">Submit</button>
                </form>

             </div>
             
           </div>
         </div>
       </div>
          <!--  -->
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";


export default {
 name:"createsuppliermodal",
 data() {
 return {
  supplier_name: "",
  contact_person: "",
  contact_email: "",
  contact_phone: "",
  address: ""
};
},
methods:{
 async submitHandler(){
    //e.preventDefault();
    
     try {
     this.apiLoading = true;
       const url = 'inventory/createItemSupplier'; 
       const body = {
            supplier_name: this.supplier_name,
            contact_person: this.contact_person,
            contact_email: this.contact_email,
            contact_phone: this.contact_phone,
            address: this.address
         };
console.log(body);
       await generalApiRequest(url, 'POST', body, 1);
      //console.log(rs);
   } catch (error) {
      console.error('Error fetching data:', error);
   }
 },
 onchangeHandler(e){
     console.log(e.target.value);
     
 },
 handleKeyUp(e){
    //  console.log(e.target.value);
     this[e.target.name] = e.target.value;
    //  console.log(this.supplier_name);
 }

},
}
</script>

<style>

</style>